/**
 * 课程详情
 */
import $share from '@/api/modules/share'
import { AsyncRequest } from '@/utils/request'
import $moment from 'moment'

const state = {
  explainInfo: {},
  courseUrl: '',
  interact: []
}

const getters = {
  explain: state => {
    return state.explainInfo
  },
  interact: state => {
    return state.interact.list
  },
  courseUrl: state => {
    return state.courseUrl
  }
}

const mutations = {
  setExplainInfo: (state, info) => {
    state.explainInfo = info
  },
  setCourseUrl: (state, str) => {
    state.courseUrl = str
  },
  setBeautifulInteract: (state, interact) => {
    // 日期转换，增加属性
    interact.list.forEach(item => {
      item.isEllipsis = true;
      item.isShowAllReply = false;
      item.createTime = $moment(item.createTime).format('YYYY.M.DD HH:mm')
      item.replies && item.replies.forEach(val => {
        val.replyTime = $moment(val.replyTime).format('YYYY.M.DD HH:mm');
      })
    })
    state.interact = interact
  }
}

const actions = {
  getCourseExplainInfo({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $share.getCourseExplainInfo(payload),
      resolve: (list) => commit('setExplainInfo', list)
    })
  },
  getCourseUrl({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $share.getCourseUrl(payload),
      resolve: (str) => commit('setCourseUrl', str)
    })
  },
  getBeautifulInteract({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $share.getBeautifulInteract(payload),
      resolve: (list) => commit('setBeautifulInteract', list)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
